<script lang="ts">
  /** D2 · CHARACTER_FN — who it is and what moves it: its card, its drives (where each starts, how fast it builds, how much it weighs
   *  in a choice), the layers it perceives (the player layer = the glasses) and what it knows from the start */
  import type { Rec } from '../types'
  let { rec }: { rec: Rec } = $props()
</script>

<div class="panel">
  <section class="card frame">
    <h3 class="caps">Card</h3>
    <p class="name">{rec.title}</p>
    <p class="muted">{rec.effective.tagline}</p>
    <blockquote>“{rec.effective.greeting}”</blockquote>
  </section>
  <section class="drives frame">
    <h3 class="caps">Drives</h3>
    <table>
      <thead><tr><th>Drive</th><th>Starts</th><th>Builds</th><th>Weight</th></tr></thead>
      <tbody>
        {#each rec.effective.drives as d}
          <tr class:own={d.weight !== 1}>
            <td class="caps">{d.name}</td>
            <td><span class="bar"><i style={`width:${d.start}%`}></i></span><span class="mono">{d.start}</span></td>
            <td class="mono">{d.rate}/min</td>
            <td class="mono">×{d.weight}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </section>
  <section class="frame">
    <h3 class="caps">Perceives</h3>
    <p class="chips">
      <span class="chip on">World</span>
      <span class="chip" class:on={rec.effective.layers.includes('player')}>Player{#if rec.effective.layers.includes('player')} · the glasses{/if}</span>
    </p>
    <h3 class="caps">Knows from the start</h3>
    <p>{#if Array.isArray(rec.effective.knows)}{#each rec.effective.knows as k}<span class="chip on mono">{k}</span>{/each}{:else}<span class="muted">{rec.effective.knows === 'all' ? 'Everything in its world.' : 'Nothing — only what it perceives.'}</span>{/if}</p>
  </section>
</div>

<style>
  .panel { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 14px; padding: 18px; align-items: start; }
  section { background: var(--panel); padding: 12px 14px; }
  h3 { margin: 0 0 8px; font-size: 13px; color: var(--muted); font-weight: 600; }
  .name { margin: 0; font-size: 26px; font-weight: 600; color: var(--cyan); }
  blockquote { margin: 10px 0 0; padding-left: 10px; border-left: 2px solid var(--line); font-size: 16px; }
  .drives { grid-column: span 2; }
  table { width: 100%; border-collapse: collapse; font-size: 15px; }
  th { text-align: left; color: var(--muted); font-weight: 500; font-size: 12px; text-transform: uppercase; letter-spacing: .05em; padding: 4px 6px; border-bottom: 1px solid var(--line-dim); }
  td { padding: 6px; border-bottom: 1px solid #18212a; }
  tr.own td:first-child { color: var(--cyan); }
  .bar { display: inline-block; width: 90px; height: 6px; background: #1b242d; margin-right: 8px; vertical-align: middle; }
  .bar i { display: block; height: 100%; background: var(--cyan); }
  .chips { display: flex; gap: 8px; flex-wrap: wrap; }
  .chip { display: inline-block; border: 1px solid var(--faint); color: var(--muted); padding: 2px 9px; margin: 0 6px 6px 0; text-transform: uppercase; letter-spacing: .05em; font-size: 13px; }
  .chip.on { border-color: var(--cyan); color: var(--cyan); }
  @media (max-width: 700px) { .drives { grid-column: auto; } .bar { width: 50px; } }
</style>
